/**
 * Whether `url` uses the http/https scheme.
 *
 * Guards links rendered from API-provided URLs (e.g. shipment tracking links)
 * against a `javascript:`/`data:` URL being used as an XSS vector.
 */
export function isHttpUrl(url: string): boolean {
  try {
    return ['http:', 'https:'].includes(new URL(url).protocol);
  } catch {
    return false;
  }
}
